import { store } from "../redux/store";

const config = {
    checkToken: true,
    headers: {}
}

function Request(AxiosInstance) {
    const Axios = AxiosInstance;

    const makeRequestAsPerMethod = async (url, method, options, body, axiosOptions) => {
        let data = null;
        let authHeader = {};
        let token;

        try {
            if (options.checkToken) {
                if (store && store.getState().auth && (store.getState().auth.token || (store.getState().auth.admin && store.getState().auth.admin.jwt))) {
                    token = store.getState().auth.token || store.getState().auth.admin.jwt;

                    authHeader = {
                        'Authorization': `Token ${token}`,
                    };
                }
                else {
                    console.log(`ERROR: Request ${url} is rejected because token check is enabled and token is not found! Try passing {checkToken: false} in options.`)
                    return
                };
            }
            switch (method.toUpperCase()) {
                case "GET":
                    data = await Axios.get(url, {
                        headers: {
                            ...options.headers,
                            ...authHeader,
                        },
                    });
                    break;
                case "POST":
                    const { params } = body;
                    data = await Axios.post(url, body, {
                        ...axiosOptions,
                        headers: {
                            ...options.headers,
                            ...authHeader,
                        },
                        params,
                    });
                    break;
                case "PUT":
                    data = await Axios.put(url, body, {
                        ...axiosOptions,
                        headers: {
                            ...options.headers,
                            ...authHeader,
                        },
                    });
                    break;
                case "DELETE":
                    data = await Axios.delete(url, {
                        headers: {
                            ...options.headers,
                            ...authHeader,
                        },
                    });
                    break;
                default:
                    break;
            }
        } catch (error) {
            console.log("URL ERRRO", url);
            console.warn(`An error occured while requesting a url : ${url} \n Error: ${JSON.stringify(error?.response?.data)}`);
        }
        finally {
            if (data) {
                return data.data;
            }
        }
    }

    /**
     * 
     * @param {string} url  The API endpoint
     * @param {object} options { checkToken: true, headers: {} }
     * @returns Promise
     */
    this.get = async function (url, options = config) {
        return await makeRequestAsPerMethod(url, 'GET', options)
    }

    /**
     * 
     * @param {string} url  The API endpoint
     * @param {object} body The request body
     * @param {object} options { checkToken: true, headers: {}, axiosOptions: {} }
     * @returns Promise
     */
    this.post = function (url, body = {}, options = { ...config, axiosOptions: {} }) {
        return makeRequestAsPerMethod(url, 'POST', options, body, options.axiosOptions)
    }

    /**
     * 
     * @param {string} url  The API endpoint
     * @param {object} body The request body
     * @param {object} options { checkToken: true, headers: {}, axiosOptions: {} }
     * @returns Promise
     */
    this.put = function (url, body = {}, options = { ...config, axiosOptions: {} }) {
        return makeRequestAsPerMethod(url, 'PUT', options, body, options.axiosOptions)
    }


    /**
     * 
     * @param {string} url  The API endpoint
     * @param {object} options { checkToken: true, headers: {} }
     * @returns Promise
     */
    this.delete = async function (url, options = config) {
        return await makeRequestAsPerMethod(url, 'DELETE', options)
    }
}

export default Request